var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Edit-Profile"},[_vm._m(0),_c('FormEditProfileVue')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Header-Edit-Profile"},[_c('h1',[_vm._v("Edit Profile")])])}]

export { render, staticRenderFns }